// extracted by mini-css-extract-plugin
export default {"movie_page":"MoviePage_movie_page__l-10O","imageSkeleton":"MoviePage_imageSkeleton__pA4Kq","backdrop":"MoviePage_backdrop__25pyI","backBtn":"MoviePage_backBtn__r6N5q"};